module.exports = __webpack_public_path__ + "static/media/extend.423d17d3.png";